import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { AddToContext } from '../../AddToContext';
import { MiniPipWrapper } from './MiniPipWrapper';

export const MiniPip = ({
  itemId, isSearchResults, isDisplayOnly, hideSalientPoints, isIntent = false, handleResolveIntent,
}) => {
  const { storeId, membershipInformation, zipCode } = useContext(AddToContext);
  return (
    <QueryProvider
      cacheKey="MiniPIP"
      dataSource="catalog"
      defaultVariables={{
        storeId,
        skipInstallServices: true,
        loyaltyMembershipInput: membershipInformation?.data?.loyaltyMembership || null,
        isBrandPricingPolicyCompliant: true,
        zipCode
      }}
    >
      <MiniPipWrapper
        itemId={itemId}
        isSearchResults={isSearchResults}
        isDisplayOnly={isDisplayOnly}
        hideSalientPoints={hideSalientPoints}
        isIntent={isIntent}
        handleResolveIntent={handleResolveIntent}
      />
    </QueryProvider>
  );
};

MiniPip.displayName = 'MiniPip';

MiniPip.propTypes = {
  itemId: PropTypes.string.isRequired,
  isSearchResults: PropTypes.bool,
  isDisplayOnly: PropTypes.bool,
  hideSalientPoints: PropTypes.bool,
  handleResolveIntent: PropTypes.func,
  isIntent: PropTypes.bool
};

MiniPip.defaultProps = {
  isSearchResults: false,
  isDisplayOnly: false,
  hideSalientPoints: false,
  handleResolveIntent: null,
  isIntent: false,
};
